import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmarContaRoutingModule } from './confirmar-conta-routing.module';
import { ConfirmarContaComponent } from './confirmar-conta.component';

import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { FormsModule } from '@angular/forms';
import { AppConfigModule } from 'src/app/layout/config/app.config.module';
import { MessagesModule } from 'primeng/messages';


@NgModule({
    imports: [
        CommonModule,
        ConfirmarContaRoutingModule,
        ButtonModule,
        InputTextModule,
        CheckboxModule,
        FormsModule,
        AppConfigModule,
        MessagesModule
    ],
    declarations: [ConfirmarContaComponent]
})
export class ConfirmarContaModule { }
